import { useParams } from 'react-router-dom';
import { RollbackOutlined } from '@ant-design/icons';
import { Button, Popconfirm } from 'antd';

import { refetchSnapDetailsAction } from 'containers/Snaps/Snap/store';

import { usePutRequest } from 'hooks';

import { Transaction } from 'codegen';

export const BackOutTransaction = ({
  status,
  statusCode,
  transactionId,
  refetchTransactions,
}: {
  status?: Transaction.status,
  statusCode?: number;
  transactionId?: number;
  refetchTransactions: () => void;
}) => {
  const { snapId } = useParams();

  const [backOutTransaction, { loading }] = usePutRequest({
    url: `/snaps/${snapId}/transactions/${transactionId}/backout`,
    options: {
      onSuccess: () => {
        refetchTransactions();
        refetchSnapDetailsAction();
      },
    },
  });

  const isBackedOut = status === Transaction.status.BACKED_OUT;
  const showSendBtn = statusCode && statusCode !== 500;

  if (!showSendBtn || isBackedOut) {
    return null;
  }

  return (
    <Popconfirm
      style={{ width: 250 }}
      title='After back out all miles for this transaction will be deleted from collector account. Are you sure to back out?'
      onConfirm={() => backOutTransaction()}
    >
      <Button
        type='text'
        icon={<RollbackOutlined title='Back Out' className='text-[#ff4d4f]' />}
        loading={loading}
      />
    </Popconfirm>
  );
};
